export default __webpack_public_path__ + "static/media/SpheroCentral_Logo_White.7d6e27ac.svg";